import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { api_url } from "../config/config";

const AccessControl = () => {
    const [vendors, setVendors] = useState([]);
    const [users, setUsers] = useState([]); 
  
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

    const [loading, setLoading] = useState(false);

    const [trigger, setTrigger] = useState(false);
    const token = localStorage.getItem("admin_token");


    const allPermissions = [
        { key: "Profile", label: "Profile" },
        { key: "EmployeeAction", label: "Employee Action" },
        { key: "AdminAction", label: "Admin Action" },
        // { key: "AccessControl", label: "Access Control" },
        { key: "Employee", label: "Employee" },
        { key: "Products", label: "Products" },
        { key: "Prescriptions", label: "Prescriptions" },
        { key: "Orders", label: "Orders" },
        { key: "Category", label: "Category" },
        { key: "Concern", label: "Concern" },
        { key: "Manufacturer", label: "Manufacturer" },
        { key: "ContentUpdate", label: "Content Update" },
        { key: "Blogs", label: "Blogs" },
        { key: "BlogsType", label: "Blogs Type" },
        { key: "ManageStores", label: "Manage Stores" },
        { key: "Payments", label: "Payments" },
        { key: "CustomerQueries", label: "Customer Queries" },
        { key: "OrderTransferHistory", label: "Order Transfer History" },
    ];

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);
        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);






    const fetchVendors = async () => {
        if (!token) {
            toast.error("Unauthorized. Please log in.");
            return;
        }
        setLoading(true);
        try {
            let url = debouncedSearchTerm
                ? `${api_url}/admin?search=${debouncedSearchTerm}`
                : `${api_url}/admin`;
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
                },
            });
            const dataArr = response.data.data;
            setVendors(dataArr);

            const mapped = (Array.isArray(dataArr) ? dataArr : []).map((v) => {
             
                let permsArr = [];
                if (v && v.permissions && typeof v.permissions === "object" && !Array.isArray(v.permissions)) {
                    permsArr = Object.keys(v.permissions).filter((k) => Boolean(v.permissions[k]));
                } else if (Array.isArray(v.permissions)) {
                    permsArr = v.permissions;
                }
                return {
                    ...v,
                    user_id: v.user_id || v.id, 
                    permissions: permsArr,
                };
            });
            setUsers(mapped);


        } catch (err) {
            toast.error(err.message);
        } finally {
            setLoading(false);
        }
    };


    const togglePermission = async (userId, permKey) => {
 
        const currentUser = users.find((u) => u.user_id === userId);
        const currentlyEnabled = currentUser?.permissions?.includes(permKey);
        const nextValue = !currentlyEnabled;

        setUsers((prev) =>
            prev.map((u) =>
                u.user_id === userId
                    ? {
                          ...u,
                          permissions: nextValue
                              ? [...u.permissions, permKey]
                              : u.permissions.filter((p) => p !== permKey),
                      }
                    : u
            )
        );

        try {
            await axios.patch(
                `${api_url}/admin/permissions/${userId}`,
                { key: permKey, value: nextValue },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
                    },
                }
            );
        } catch (err) {
         
            setUsers((prev) =>
                prev.map((u) =>
                    u.user_id === userId
                        ? {
                              ...u,
                              permissions: currentlyEnabled
                                  ? [...u.permissions, permKey]
                                  : u.permissions.filter((p) => p !== permKey),
                          }
                        : u
                )
            );
            toast.error(err?.response?.data?.message || err.message || "Failed to update permission");
        }
    };

 

    useEffect(() => {
        fetchVendors();
    }, [debouncedSearchTerm, trigger]);

    return (
        <div className="flex flex-col">
        <div className="flex-grow overflow-auto">
            <h2 className="text-2xl font-bold mb-4 mt-7">Access Control</h2>
            <div className="bg-white p-6 rounded-lg shadow-lg">
                <div className="w-full flex items-center justify-between gap-5 mb-4">
                    <input
                        type="text"
                        className="border rounded-xl border-slate-700 p-2 w-[300px] px-3"
                        placeholder="Search by Name..."
                        value={searchTerm}
                        onChange={e => {
                            setSearchTerm(e.target.value);
                        }}
                    />
                   
                </div>
                <div className="overflow-auto max-h-[500px] border rounded-md">
                <table className="table-auto w-full min-w-max text-sm text-left">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="px-6 py-3 border">Employee ID</th>
                            <th className="px-6 py-3 border">Employee Name(Role)</th>
                            {allPermissions.map((p) => (
                                <th key={p.key} className="p-2 border text-center">{p.label}</th>
                            ))}
                        
                            
                        </tr>
                    </thead>
                    <tbody>
                        {users.length === 0 ? (
                            <tr>
                                <td colSpan={5} className="text-center py-8 text-gray-500">
                                    No employees found matching your search.
                                </td>
                            </tr>
                        ) : (
                            users.map((u) => (
                                <tr key={u.user_id} className="p-2 border">
                                    <td className="px-6 py-3 border">{u.employee_id || "N/A"}</td>
                                    <td className="px-6 py-3 border">{u.name}({u.role})</td>
                                    {allPermissions.map((p) => (
                                        <td key={p.key} className="p-2 border text-center">
                                            <input
                                                type="checkbox"
                                                checked={u.permissions.includes(p.key)}
                                                onChange={() => togglePermission(u.user_id, p.key)}
                                                className="cursor-pointer"
                                            />
                                        </td>
                                    ))}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
                </div>
               
               
            </div>
        </div>
    </div>
    
    );
};

export default AccessControl;
